import React, { useEffect, useState } from 'react'

export const ContextNav = React.createContext<any>({})


export default function ContextNavModels(props: any) {
    const [displayNavMobile, setDisplayNavMobile] = useState<boolean>(false)
    const [activeMenuItem, setActiveMenuItem] = useState<any>({
        'item':0 ,
        'subItem': 0 ,
    })



    return (
        <ContextNav.Provider value={{
            displayNavMobile,
            setDisplayNavMobile ,
            activeMenuItem , 
            setActiveMenuItem ,
        }}>
            {props.children}
        </ContextNav.Provider>
    )
}